import { ResolverService } from './shared/resolver/resolver.service';
import { AuthGuardService } from './shared/auth-guard/auth-guard.service';
import { HeaderBodyFooterAdderComponent } from './theme/header-body-footer-adder/header-body-footer-adder.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlockRouteResolverForSentryService } from './shared/blockRouteResolverForsentry/block-route-resolver-for-sentry.service';
import { HttpComponent } from './static-pages/http/http.component';
import { HttpErrorComponent } from './static-pages/http-error/http-error.component';
import { directLiginComponent } from './static-pages/direct-login/direct-login.component';

const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },

  {
    path: '',
    component: HeaderBodyFooterAdderComponent,
    children: [
      {
        path: '',
        loadChildren: './dashboard-landing-page/dashboard-landing-page.module#DashboardLandingPageModule',
        data: {
          title: 'Home',
          description: ''
        }
      },
      {
        path: 'login', resolve: { ResolverService }, loadChildren: './login/login.module#LoginModule',
        data: {
          title: 'Login',
          description: ''
        }
      },
      {
        path: 'direct-login', component: directLiginComponent,
        data: {
          title: 'Login',
          description: ''
        }
      },
      {
        path: 'candidate-login', resolve: { ResolverService }, loadChildren: './candidate-login/candidate-login.module#candidateLoginModule',
        data: {
          title: 'Candidate Login',
          description: ''
        }
      },
      {
        path: 'http-error',component:HttpComponent,
        data: {
          title: 'HTTP-Error',
          description: ''
        }
      },
      {
        path: 'url-error',component:HttpErrorComponent,
        data: {
          title: 'URL-Error',
          description: ''
        }
      },
      // {
      //   path: 'candidate-registration',
      //   loadChildren: './candidate-registration/candidate-registration.module#CandidateRegistrationModule',
      //   data: {
      //     title: 'Candidate Registration',
      //     description: ''
      //   }

      // },
      {
        path: 'mela-registration',
        loadChildren: './mela-registration/mela-registration.module#MelaRegistrationModule',
        data: {
          title: 'Candidate/Establishment Registration',
          description: ''
        }

      },
      // {
      //   path: 'college-registration',
      //   loadChildren: './college-registration/college-registration.module#CollegeRegistrationModule',
      //   data: {
      //     title: 'College Registration',
      //     description: ''
      //   }

      // },
      {
        path: 'tpa-registration',
        loadChildren: './tpa-registration/tpa-registration.module#TpaRegistrationModule',
        data: {
          title: 'TPA Registration',
          description: ''
        }

      },
      {
        path: 'btp-registration',
        loadChildren: './btp-registration/btp-registration.module#BTPRegistrationModule',
        data: {
          title: 'BTP Registration',
          description: ''
        }

      },
      {
        path: 'order-status',
        loadChildren: './payment-order/payment-order.module#PaymentOrderModule',
        data: {
          title: 'Payment Information',
          description: ''
        }

      },
      {
        path: 'order-status/cancel',
        loadChildren: './payment-order/payment-order.module#PaymentOrderModule',
        data: {
          title: 'Payment Information',
          description: ''
        }

      },
      {
        path: 'establishment-registration',
        loadChildren: './establishment-registration/establishment-registration.module#EstablishmentRegistrationModule',
        data: {
          title: 'Establishment Registration',
          description: ''
        }
      },
      {
        path: 'pmnam-map',
        loadChildren: './india-map/india-map.module#indiaMapModule',
        data: {
          title: 'India Map',
          description: ''
        }
      },
     
      // {
      //   path: 'order-details',
      //   loadChildren: './nimi-payment-status/nimi-payment-status.module#NimiPaymentStatusModule',
      //   data: {
      //     title: 'Payment Status',
      //     description: ''
      //   }
      // },
      {
        path: 'nimi/order-status',
        loadChildren: './nimi-payment-status/nimi-payment-status.module#NimiPaymentStatusModule',
        data: {
          title: 'Payment Status',
          description: ''
        }
      },
      {
        path: 'apprenticeship',
        loadChildren: './apprentice-opportunities/apprentice-opportunities.module#ApprenticeOpportunitiesModule',
        data: {
          title: 'All Opportunities',
          description: ' '
        }
      },
      {
        path: 'courses',
        loadChildren: './all-published-courses/all-published-courses.module#AllPublishedCoursesModule',
        data: {
          title: 'All Published Courses'
        }
      },
      { path: 'dashboard', resolve: { ResolverService }, loadChildren: './login/login.module#LoginModule' },
      {
        path: 'candidate',
        canLoad: [AuthGuardService],
        data: {
          allowedRole: 'candidate'
        },
        resolve: { BlockRouteResolverForSentryService },
        loadChildren: './candidate/candidate.module#CandidateModule'
      },
      {
        path: 'activate/:userId/:token',
        loadChildren: './dashboard-landing-page/dashboard-landing-page.module#DashboardLandingPageModule'
      },
      {
        path: 'activate-email/:userIdEmail/:tokenEmail',
        loadChildren: './dashboard-landing-page/dashboard-landing-page.module#DashboardLandingPageModule'
      },
      {
        path: 'apprentice/services',
        loadChildren: './apprentice-services/apprentice-services.module#ApprenticeServicesModule',
        data: {
          title: 'Apprentice Services'
        }
      },
    ]
  },
  {
    path: '', component: HeaderBodyFooterAdderComponent,
    children: [
      {
        path: '**', resolve: { ResolverService }, loadChildren: './login/login.module#LoginModule',
        data: {
          title: 'Login',
          description: ''
        }
      },
    ]
  },
  // {
  //   path: '**', component: PageNotFoundComponent,
  //   data: {
  //     title: 'Page Not Found',
  //     description: ''
  //   }
  // }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
